/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Facts_LocationInputs */

const en_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Germany`)
};

const de_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Deutschland`)
};

const fr_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Allemagne`)
};

const es_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Alemania`)
};

const it_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Germania`)
};

const nl_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Duitsland`)
};

const pl_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Niemcy`)
};

const fi_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Saksa`)
};

const da_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Tyskland`)
};

const sv_about_facts_location = /** @type {(inputs: About_Facts_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aichach, Tyskland`)
};

/**
* | output |
* | --- |
* | "Aichach, Germany" |
*
* @param {About_Facts_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_facts_location = /** @type {((inputs?: About_Facts_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Facts_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_facts_location(inputs)
	if (locale === "fr") return fr_about_facts_location(inputs)
	if (locale === "es") return es_about_facts_location(inputs)
	if (locale === "it") return it_about_facts_location(inputs)
	if (locale === "nl") return nl_about_facts_location(inputs)
	if (locale === "pl") return pl_about_facts_location(inputs)
	if (locale === "fi") return fi_about_facts_location(inputs)
	if (locale === "da") return da_about_facts_location(inputs)
	if (locale === "sv") return sv_about_facts_location(inputs)
	return en_about_facts_location(inputs)
});